var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.send()}}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("mdi-whatsapp")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }